import styled from 'foundations-theming/utils';
import H5 from 'UIComponents/elements/headings/H5';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { BUTTON_RADIUS } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OuterContainer = styled.div.withConfig({
  displayName: "TriggerGroupContainer__OuterContainer",
  componentId: "sc-1oalo2r-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";padding:8px 12px 12px;"], ({
  theme
}) => theme.color['do-not-use-koala'], ({
  theme
}) => theme.color['do-not-use-flint'], BUTTON_RADIUS);
const InnerContainer = styled.div.withConfig({
  displayName: "TriggerGroupContainer__InnerContainer",
  componentId: "sc-1oalo2r-1"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";padding:8px 12px;"], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-eerie'], BUTTON_RADIUS);
const Header = styled(H5).withConfig({
  displayName: "TriggerGroupContainer__Header",
  componentId: "sc-1oalo2r-2"
})(["line-height:32px;"]);
export default function TriggerGroupContainer({
  label,
  children,
  onDelete,
  className,
  innerClassName
}) {
  return /*#__PURE__*/_jsxs(OuterContainer, {
    className: className,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-row align-center m-bottom-1",
      children: [/*#__PURE__*/_jsx(Header, {
        className: "m-y-0 flex-grow-1",
        children: label
      }), onDelete && /*#__PURE__*/_jsx(UIIconButton, {
        use: "transparent",
        size: "sm",
        className: "no-shrink display-block",
        onClick: onDelete,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "delete"
        })
      })]
    }), /*#__PURE__*/_jsx(InnerContainer, {
      className: innerClassName,
      children: children
    })]
  });
}